import * as React from 'react';

interface CurrentPosition {
  currentPosition: google.maps.LatLng | null;
}

export const CurrentPositionContext = React.createContext<CurrentPosition>({
  currentPosition: null,
});
